module.exports = __webpack_public_path__ + "img/thumbnail_Bongo_f_normal.fa5a8df7.png";